import { render } from "./AdminDesktop.vue?vue&type=template&id=20ac4140"
import script from "./AdminDesktop.vue?vue&type=script&lang=js"
export * from "./AdminDesktop.vue?vue&type=script&lang=js"

import "./AdminDesktop.vue?vue&type=style&index=0&id=20ac4140&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__